import { render, staticRenderFns } from "./AskParameters.vue?vue&type=template&id=64600293&scoped=true&"
import script from "./AskParameters.vue?vue&type=script&lang=js&"
export * from "./AskParameters.vue?vue&type=script&lang=js&"
import style0 from "./AskParameters.vue?vue&type=style&index=0&id=64600293&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64600293",
  null
  
)

export default component.exports